import {Mixins, Component } from 'vue-property-decorator'
// import gql from 'graphql-tag'

import {Dataset as DatasetType } from '@/@types/graphql'
import DatasetService from './Dataset'

@Component({ name: 'notification-service' })
export default class Dataset extends Mixins(DatasetService) {

    async GET_NOTIFICATION (): Promise<DatasetType> {
        const data = await this.GET_DATASET('notification')
    // const variables = { key: 'notification' }
    // const query = gql`      
    //     query dataset ($key: String!) {
    //         dataset (key: $key) {
    //             value
    //         }
    //     }
    // `
    // const { data } = await this.$apollo.query({ query, variables })
    // return data.dataset?.value
        return data?.value
  }

}
